module.exports = __webpack_public_path__ + "static/CPCS-logo-1208b6f25367a9950b9fdc7994edbb43.png";